import { csrfFetch } from "../api/csrfFetch";
import { membersLink } from "../credentials/consts/links";
export var ApiAccount;
(function (ApiAccount) {
    ApiAccount.get = () => csrfFetch({
        url: membersLink + "/api/v1/customers/accounts",
        withCredentials: true,
    });
})(ApiAccount || (ApiAccount = {}));
